import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'

type ConfirmationDialogProps = {
  openDialog: boolean
  modalTitle: string
  modalBody: string
  confirmButtonText?: string
  dismissButtonText?: string
  onConfirm: () => void
  onDismiss: () => void
}

export const ConfirmationDialogModal = ({
  openDialog,
  onConfirm,
  onDismiss,
  modalTitle,
  modalBody,
  confirmButtonText,
  dismissButtonText,
}: ConfirmationDialogProps) => {
  const { t } = useTranslation(['installations', 'common'])
  return (
    <Dialog
      open={openDialog}
      onClose={onDismiss}
      aria-label="update-installation-confirmation"
      data-testid="update-installation-confirmation"
    >
      <DialogTitle>{modalTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ paddingLeft: 0, paddingRight: 0, textAlign: 'start' }}>{modalBody}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDismiss}>{dismissButtonText ?? t('common:cancel')}</Button>
        <Button onClick={onConfirm}>{confirmButtonText ?? t('common:accept')}</Button>
      </DialogActions>
    </Dialog>
  )
}
